package dev.lingvo.shared

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

/** Separates envelope compatibility from the engine document schema. */
@Serializable
data class ScreenshotDesignEnvelope(val schemaVersion: Int, val document: JsonObject)

/** Optimistic versions prevent concurrent editors from overwriting each other. */
@Serializable
data class PutScreenshotDesignRequest(val baseVersion: Int, val design: ScreenshotDesignEnvelope)

/** A restore is a new version guarded against concurrent saves. */
@Serializable
data class RestoreDesignRequest(val baseVersion: Int)

/** Validation findings retain JSON pointers for editor repair links. */
@Serializable
data class DesignIssueDto(val code: String, val path: String, val message: String, val severity: String)

/** Carries the canonical saved document and its audit provenance. */
@Serializable
data class ScreenshotDesignDto(
    val platform: StorePlatform, val version: Int, val schemaVersion: Int, val document: JsonObject,
    val sha256: String, val byteSize: Int, val savedBy: String, val savedAt: String,
    val restoredFrom: Int? = null, val warnings: List<DesignIssueDto> = emptyList(),
)

/** History summaries avoid transferring every document when opening the version picker. */
@Serializable
data class DesignVersionSummaryDto(
    val version: Int, val schemaVersion: Int, val byteSize: Int, val savedBy: String,
    val savedAt: String, val restoredFrom: Int? = null, val snapshot: DesignSnapshotDto? = null,
)

/** Asset roles bound how artwork may be used in a design. */
@Serializable
enum class DesignAssetKind { BACKGROUND, LOGO, DEVICE_ART }

/** Asset metadata lets editors load authenticated image bytes separately. */
@Serializable
data class DesignAssetDto(
    val id: String, val kind: DesignAssetKind, val format: ImageFormat, val width: Int, val height: Int,
    val byteSize: Int, val sha256: String, val imagePath: String, val createdBy: String, val createdAt: String,
)
